// extracted by mini-css-extract-plugin
export default {"progressSpinner":"InfiniteScroll_progressSpinner__OGnOk","scrollEnd":"InfiniteScroll_scrollEnd__TOrCu"};